import ManagementPage from './ManagementPage';
import { Tabs } from 'lynkco-up-core';
import { Tab } from 'lynkco-up-core/dist/types/components/Tabs';

function ManagementTab() {
  const tabs: Tab[] = [
    {
      name: 'CX11 A1',
      content: <ManagementPage filteredModel={'CX11_A1'} />,
    },
    {
      name: 'CX11 A3/E335/DX11',
      content: <ManagementPage filteredModel={'CX11_A3,E335,DX11'} />,
      isActive: true,
    },
  ];

  return (
    <section className="p-2 py-1">
      <Tabs tabsName="Car-Models" tabs={tabs} />
    </section>
  );
}

export default ManagementTab;
